import Immutable from 'immutable';
import {
  HOME_PATH,
  SALES_SESSION_PATH,
  DEPOSIT_PATH,
  PRICING_PROFILE_PATH,
  LIQUIDATION_SESSION_PATH,
  GENERAL_INCOME_PATH,
  DISCOUNT_TO_BENEFICIARIES_PATH,
  EXPENSE_STATUS_PATH,
  CREDIT_NOTE_PATH,
  DISCOUNT_CODE_PATH,
  DISCOUNT_CODE_CATEGORY_PATH,
  DISCOUNT_CODE_AUTHORIZER_PATH,
  PRICING_PROFILE_DATE_RANGE_PATH,
  PRICING_PROFILE_MASSIVE_UPDATE_PATH,
  FREE_OF_CHARGE_CATEGORY_PATH,
  FREE_OF_CHARGE_RULE_PATH,
  BANK_RECONCILIATION_PATH,
  DEPOSIT_MIGRATION_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      key: 'pricing-profile-date-ranges',
      title: 'Rango de Fechas para Perfiles de Precio',
      path: PRICING_PROFILE_DATE_RANGE_PATH,
      icon: 'calendar-o',
    },
    {
      key: 'pricing-profiles',
      title: 'Perfiles de Precios',
      path: PRICING_PROFILE_PATH,
      icon: 'list-ul',
    },
    {
      key: 'pricing-profile-massive-update',
      title: 'Actualización Masiva de Perfiles de Precio',
      path: PRICING_PROFILE_MASSIVE_UPDATE_PATH,
      icon: 'file-excel-o',
    },
    {
      key: 'sales-session',
      title: 'Sesiones de Ventas',
      path: SALES_SESSION_PATH,
      icon: 'calculator',
    },
    {
      key: 'customer-orders',
      title: 'Órdenes',
      path: '/sales/customer-orders',
      icon: 'book',
      disabled: true,
    },
    {
      key: 'discount-codes',
      title: 'Códigos de Descuento',
      path: DISCOUNT_CODE_PATH,
      icon: 'minus-square-o',
    },
    {
      key: 'discount-code-categories',
      title: 'Categorías de Códigos de Descuento',
      path: DISCOUNT_CODE_CATEGORY_PATH,
      icon: 'list-ol',
    },
    {
      key: 'discount-code-authorizers',
      title: 'Autorizadores de Códigos de Descuento',
      path: DISCOUNT_CODE_AUTHORIZER_PATH,
      icon: 'address-book',
    },
    {
      key: 'free-of-charge-categories',
      title: 'Categorías de Descuento Gratuito',
      path: FREE_OF_CHARGE_CATEGORY_PATH,
      icon: 'gift',
    },
    {
      key: 'free-of-charge-rules',
      title: 'Reglas para Servicios a Título Gratuito',
      path: FREE_OF_CHARGE_RULE_PATH,
      icon: 'list-alt',
    },
    {
      key: 'expenses',
      title: 'Egresos',
      path: '/sales/expense',
      icon: 'usd',
    },
    {
      key: 'liquidation-session',
      title: 'Liquidaciones de Agencia',
      path: LIQUIDATION_SESSION_PATH,
      icon: 'legal',
    },
    {
      key: 'credit-notes',
      title: 'Notas de Crédito',
      path: CREDIT_NOTE_PATH,
      icon: 'credit-card-alt',
    },
    {
      key: 'general-income',
      title: 'Ingresos',
      path: GENERAL_INCOME_PATH,
      icon: 'usd',
    },
    {
      key: 'deposits',
      title: 'Depósitos',
      path: DEPOSIT_PATH,
      icon: 'usd',
    },
    {
      key: 'bank-reconciliation',
      title: 'Conciliación Bancaria',
      path: BANK_RECONCILIATION_PATH,
      icon: 'university',
    },
    {
      key: 'deposit-migration',
      title: 'Cargas del Estado de Cuenta',
      path: DEPOSIT_MIGRATION_PATH,
      icon: 'file-excel-o',
    },
    {
      key: 'discount-to-beneficiaries',
      title: 'Descuento para Beneficiaros',
      path: DISCOUNT_TO_BENEFICIARIES_PATH,
      icon: 'file-excel-o',
    },
    {
      key: 'expense-authorization',
      title: 'Autorización de Egresos',
      path: EXPENSE_STATUS_PATH,
      icon: 'lock',
    },
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Gestión de Ventas',
      tag: 'span',
      href: '/sales',
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
